import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class RestaurantConfigService {

    static addRestaurantConfig = (data, id) => {
        return axios.post(`${PATH.ADD_RESTAURANT_CONFIG}/${id}`, data);
    }

    static getRestaurantConfigList = id => {
        return axios.get(`${PATH.GET_RESTAURANT_CONFIG_LIST}/${id}`);
    }

    static getRestaurantConfigById = (id, restaurantId) => {
        return axios.get(`${PATH.GET_RESTAURANT_CONFIG_BY_ID}/${id}/${restaurantId}`);
    }

    static getActiveRestaurantConfigById = restaurantId => {
        return axios.get(`${PATH.GET_ACTIVE_RESTAURANT_CONFIG_BY_ID}/${restaurantId}`);
    }

    static editRestaurantConfig = (data, id, restaurantId) => {
        return axios.put(`${PATH.EDIT_RESTAURANT_CONFIG}/${id}/${restaurantId}`, data);
    }

}
